import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    fileField: {
        marginTop: theme.spacing(3),
    },
    parseErrorAlert: {
        marginTop: theme.spacing(2),
    },
    previewContainer: {
        marginTop: theme.spacing(2),
    },
    noImportableAlert: {
        marginTop: theme.spacing(1),
    },
    previewList: {
        maxHeight: 300,
        overflowY: "auto",
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: 4,
        marginTop: theme.spacing(1),
    },
    leadingIcons: {
        minWidth: 0,
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    chevron: {
        fontSize: 14,
        width: 14,
    },
    indexNumber: {
        minWidth: 16,
        textAlign: "right",
    },
    entryText: {
        marginLeft: theme.spacing(1.5),
    },
    statusIconWrapper: {
        minWidth: 0,
    },
    statusIconError: {
        color: theme.palette.emteria.error,
    },
    statusIconWarning: {
        color: theme.palette.emteria.warning,
    },
    statusIconSuccess: {
        color: theme.palette.emteria.success,
    },
    detailsBox: {
        padding: theme.spacing(1, 2, 2, 6),
        overflowX: "auto",
    },
    detailsJson: {
        margin: 0,
        fontSize: 12,
    },
}));
